import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Attachment({ reportId, type, token }) {
  const [url, setUrl] = useState("");

  useEffect(() => {
    let created;
    axios
      .get(`${API}/reports/attachment/${reportId}`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      })
      .then((r) => {
        created = URL.createObjectURL(r.data);
        setUrl(created);
      })
      .catch(() => {});
    return () => {
      if (created) URL.revokeObjectURL(created);
    };
  }, [reportId, token]);

  if (!url) return null;
  const isVideo = (type || "").startsWith("video");
  return isVideo ? (
    <video data-testid={`attachment-${reportId}`} src={url} controls playsInline
      className="mt-4 w-full max-h-80 rounded border border-white/10 bg-black" />
  ) : (
    <img data-testid={`attachment-${reportId}`} src={url} alt="session attachment"
      className="mt-4 w-full max-h-80 object-contain rounded border border-white/10 bg-black" />
  );
}
